import { render } from "./IconLoader2.vue?vue&type=template&id=53f6d077"
import script from "./IconLoader2.vue?vue&type=script&lang=js"
export * from "./IconLoader2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__